import type { PropertyData, PropertyDataRateEnum } from "libs/codegen/property-onboarding";
import { Fragment } from "react";
import { useWatch } from "react-hook-form";
import { rateMapper } from "./constants";
import { MonthlyPromotionController } from "./discounts/MonthlyPromotionController";
import { WeeklyPromotionController } from "./discounts/WeeklyPromotionController";

export const WeeklyMonthly = () => {
    const rate = useWatch<PropertyData>({
        name: "rate",
    }) as PropertyDataRateEnum;

    if (rate === rateMapper.ChannelManager) return null;

    return (
        <Fragment>
            <WeeklyPromotionController />
            <MonthlyPromotionController />
        </Fragment>
    );
};
